import { h } from "preact";

function ImageNoReusableComponents({
    class: cssClass
}: {
    class?: string;
}) {
    return (
        <svg class={cssClass} width="212" height="136" viewBox="0 0 212 136" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#t44jdqmcaa)">
                <path d="M.5.5h211v135H.5V.5z" fill="var(--background-primary)" stroke="var(--control-default)"/>
                <path d="M164 1h47v134h-47V1z" fill="var(--background-tertiary)"/>
                <path d="M16.5 16.5h131v103h-131v-103z" fill="var(--background-primary)" stroke="var(--control-default)"/>
                <path d="M24 24h116v16H24V24zm0 20h26v14H24V44zm30 0h26v14H54V44zM24 62h56v50H24V62zm60-18h56v14H84V44zm0 18h56v14H84V62zm0 36h56v14H84V98zm0-18h26v14H84V80zm30 0h26v14h-26V80z" fill="var(--control-default)"/>
                <path d="M54.5 44.5h25v13h-25v-13zm30 36h25v13h-25v-13zm24-52h7v7h-7v-7zm-12 0h7v7h-7v-7zm-12 0h7v7h-7v-7zm0 16h55v13h-55v-13zm84 0h39v13h-39v-13z" fill="var(--marker-blue)" fill-opacity=".15" stroke="var(--marker-blue)"/>
                <path d="M168 62h40v14h-40V62zm0-36h40v14h-40V26zm0-18h40v14h-40V8zm0 72h40v14h-40V80zm0 18h40v14h-40V98zm0 18h40v14h-40v-14z" fill="var(--control-default)"/>
                <path d="M84.5 98.5h55v13h-55v-13z" fill="var(--marker-blue)" fill-opacity=".15" stroke="var(--marker-blue)"/>
                <path d="M114.5 80.5h25v13h-25v-13z" fill="var(--marker-peach)" fill-opacity=".15" stroke="var(--marker-peach)"/>
                <path d="M24.5 44.5h25v13h-25v-13zm60 18h55v13h-55v-13zm-45 18h25v13h-25v-13z" fill="var(--marker-green)" fill-opacity=".15" stroke="var(--marker-green)"/>
                <path d="M54 41h17v3H54v-3zm30 36h17v3H84v-3z" fill="var(--marker-blue)"/>
            </g>
            <defs>
                <clipPath id="t44jdqmcaa">
                    <path fill="var(--background-primary)" d="M0 0h212v136H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default ImageNoReusableComponents;

